// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "/#11",
    },
    {
      icon: <TwitterIcon />,
      link: "/#12",
    },
    {
      icon: <GitHubIcon />,
      link: "/#13",
    },
    {
      icon: <YouTubeIcon />,
      link: "/#14",
    },
  ],
  menus: [
    {
      name: "شرکت توکای ایران",
      items: [
        { name: "درباره ما", href: "/about-us" },
        { name: "تماس با ما", href: "/contact-us" },
      ],
    },
    {
      name: "محصولات",
      items: [
        { name: "تکدید", href: "/#1" },
        { name: "سفارشی و نسخه ای", href: "/#2" },
        { name: "پوشش ها", href: "/#3" },
      ],
    },
    {
      name: "پوشش ها",
      items: [
        { name: "تکدید", href: "/#4" },
        { name: "سفارشی و نسخه ای", href: "/#5" },
        { name: "پوشش ها", href: "/#6" },
      ],
    },
    {
      name: "مقالات",
      items: [
        { name: "تکدید", href: "/#7" },
        { name: "سفارشی و نسخه ای", href: "/#8" },
        { name: "پوشش ها", href: "/#9" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular" dir="ltr">
      All rights reserved. Copyright &copy; {date} Iran Tokai by{" "}
      <MKTypography
        component="a"
        href="/"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        tokaiiran.com
      </MKTypography>
      .
    </MKTypography>
  ),
};
